import styled from 'styled-components';
import { rem, media, themed } from '@/shared/ui/core';

export const EmptyDataImageText = styled.div.attrs({
  className: 'EmptyDataImageText',
})`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    > .Title {
      font-size: 1.5625rem;
      color: ${themed('primary.text')};
      margin-bottom: 1.75rem;
      align-self: center;
    }

    >div {
      display: flex;
      flex-direction: column;
      justify-content: center;

      @media ${media.tabletMin} {
        flex-direction: row;
      }
    }
  `;

export const ContentWrapper = styled.div.attrs({
  className: 'ContentWrapper',
})`
  width: 100%;

  img {
    max-width: ${rem(233)};
    height: auto;
    object-fit: cover;
    object-position: 0 100%;
    margin: auto;
    margin-bottom: 1rem;

    @media ${media.tabletMin} {
      max-width: 14rem;
      margin-right: 1.5rem;
    }
  }
`;

export const TextBtnWrapper = styled.div.attrs({
  className: 'TextBtnWrapper',
})`
  display: flex;
  flex-direction: column;

  .Title {
    font-size: ${rem(18)};
    text-align: center;
    margin-bottom: 0.125rem;
  }
  .Text {
    margin-bottom: 1.875rem;
    text-align: center;
  }
  .component__button {
    height: 3.125rem;
    padding: 0.5rem;

    @media ${media.tabletMin} {
      font-size: 0.9375rem;
      max-width: 13.625rem;
      height: 2rem;
      padding: 0.125rem 0.25rem 0;
      margin-top: 1.5rem;
    }
  }

  @media ${media.tabletMin} {
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    width: 21rem;

    .Title {
      text-align: left;
    }

    .Text {
      margin-bottom: 1rem;
      text-align: left;
    }

    .component__button {
      margin-left: 0;
    }
  }
`;
